/** Single source of truth for connector-platform → logo asset mappings used
 *  by the catalog-operations chips. Keep this list aligned with the
 *  platform names produced by `toPlatformName` in the mapper. */
export const PLATFORM_LOGO: Record<string, string> = {
  Google: '/assets/images/google.svg',
  Meta: '/assets/images/meta.svg',
};
